import { render, staticRenderFns } from "./FixedBox.vue?vue&type=template&id=2606b1c3"
import script from "./FixedBox.vue?vue&type=script&lang=js"
export * from "./FixedBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports